import React from "react";

import { cn } from "@/utils/cn";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "red";
  children?: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({
  className,
  variant = "default",
  children,
  ...props
}) => {
  let variantClassName;
  switch (variant) {
    case "red":
      variantClassName =
        "bg-gradient-to-r from-[#fef2f2] to-[#ffe2e2] rounded border border-[#ffc9c9] shadow shadow-gray-110/25 p-8 xl:p-10";
      break;
    case "default":
    default:
      variantClassName =
        "bg-white rounded shadow shadow-gray-110/25 p-8 border border-gray-100 text-gray-1200 xl:p-10";
  }

  return (
    <div
      className={cn(variantClassName, className)}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
